import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const excluirCaracteristicasAptoService = async (id: number) => {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/caracteristicas-apto/${id}`;

    try {
      const response = await axios.delete(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
